import { render, staticRenderFns } from "./ServerMonitor.vue?vue&type=template&id=69dafcd0&scoped=true"
import script from "./ServerMonitor.vue?vue&type=script&lang=ts"
export * from "./ServerMonitor.vue?vue&type=script&lang=ts"
import style0 from "./ServerMonitor.vue?vue&type=style&index=0&id=69dafcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dafcd0",
  null
  
)

export default component.exports